export default __webpack_public_path__ + "f46586e0c8fbc3991560631f1bdca066.svg";